/**
 * Bandeau de l'espace élève quand le compte est GÉRÉ par un parent (créé depuis
 * son app, migration 0301) : l'enfant révise sur le téléphone du parent, qui
 * revient sur son compte avec son code PIN. Rien pour un élève autonome.
 */

import { useState } from 'react';
import { ArrowLeftRight } from 'lucide-react';
import { useAuth } from '@/lib/auth';
import { useManagingParent } from '@/lib/parent/managed-children';
import { SwitchBackDialog } from './switch-account-dialogs';

export function ManagedChildBar() {
  const { user, profile } = useAuth();
  const managing = useManagingParent(profile?.role === 'student' ? user?.id : undefined);
  const [open, setOpen] = useState(false);
  if (!managing.data) return null;

  return (
    <>
      <div className="bg-primary-50 ocean:bg-white/5 border-primary-100 ocean:border-white/10 flex items-center gap-2 border-b px-4 py-1.5">
        <p className="text-ink-700 min-w-0 flex-1 truncate text-sm">
          Compte de <span className="font-semibold">{profile?.display_name ?? 'ton enfant'}</span>
        </p>
        <button
          type="button"
          onClick={() => setOpen(true)}
          className="text-primary-700 ocean:text-primary-300 flex min-h-[2.75rem] shrink-0 items-center gap-1.5 text-sm font-semibold active:scale-[0.98]"
        >
          <ArrowLeftRight className="h-4 w-4" aria-hidden />
          Revenir au compte parent
        </button>
      </div>
      {open && <SwitchBackDialog onClose={() => setOpen(false)} />}
    </>
  );
}
